// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f033667b","453":"a57dd610","732":"0a432c59","977":"1a7affca"}[chunkId] + ".chunk.js";
};